import Vue from 'vue';
import axios from 'axios';

export default {
    install(Vue, options) {
        Vue.prototype.$axios = axios;

        Vue.prototype.$API_URL = process.env.API_URL;
        Vue.prototype.$storageURL = process.env.STORAGE_URL;

        Vue.prototype.$LIVE_COUNT_API = process.env.API_URL + 'api/matches/live/count';
        Vue.prototype.$COUNTRY_TOURNAMENTS_API = process.env.API_URL + 'api/tournament/countries';

        Vue.prototype.$MATCHES_API = process.env.API_URL + 'api/matches';
        Vue.prototype.$MATCH_DETAIL_API = process.env.API_URL + 'api/match/:match';
        Vue.prototype.$MATCH_COMMENTARY_API = process.env.API_URL + 'api/match/:match/commentary';
        Vue.prototype.$MATCH_INFO_API = process.env.API_URL + 'api/match/:match/info';
        Vue.prototype.$MATCH_TEAM_API = process.env.API_URL + 'api/match/:match/teams';
        Vue.prototype.$MATCH_SCORECARD_API = process.env.API_URL + 'api/match/:match/scorecard';
        Vue.prototype.$MATCH_STANDINGS_API = process.env.API_URL + 'api/tournament/standings?match=:match';
        Vue.prototype.$MATCH_UPCOMING_API = process.env.API_URL + 'api/match/:match/upcoming';
        Vue.prototype.$MATCH_NEWS_API = process.env.API_URL + 'api/match/:match/news';
        Vue.prototype.$MATCH_HIGHLIGHTS_API = process.env.API_URL + 'api/match/:match/highlights';
        Vue.prototype.$MATCH_INFO_API = process.env.API_URL + 'api/match/:match/info';
        Vue.prototype.$MATCH_TEAM_API = process.env.API_URL + 'api/match/:match/teams';
        Vue.prototype.$MATCH_COMMENTRY_API = process.env.API_URL + 'api/match/commentary/:match';
        Vue.prototype.$MATCH_POINT_API = process.env.API_URL + 'api/match/:match/get-ball-point';

        Vue.prototype.$TOURNAMENT_DETAIL_API = process.env.API_URL + 'api/tournament/:tournament';
        Vue.prototype.$TOURNAMENT_STANDINGS_API = process.env.API_URL + 'api/tournament/standings/:tournament';
        Vue.prototype.$TOURNAMENT_TEAMS_API = process.env.API_URL + 'api/tournament/:tournament/teams';
        Vue.prototype.$TOURNAMENT_STATS_API = process.env.API_URL + 'api/tournament/:tournament/stats';

        Vue.prototype.$TEAM_DETAIL_API = process.env.API_URL + 'api/tournament/:tournament/team/:team';
        Vue.prototype.$TEAM_DETAILS_API = process.env.API_URL + 'api/teams/:team';// new make
        Vue.prototype.$TEAM_PLAYERS_DETAIL_API = process.env.API_URL + 'api/:team/players';// new make
        Vue.prototype.$TEAM_MATCHES_DETAIL_API = process.env.API_URL + 'api/:team/matches';//new make
        Vue.prototype.$TEAM_NEWS_API = process.env.API_URL + 'api/:team/news'; //new make for news
        Vue.prototype.$PLAYER_DETAIL_API = process.env.API_URL + 'api/player/:player'; //new make for player detail

        Vue.prototype.$PLAYER_MATCHES_DETAIL_API = process.env.API_URL + 'api/player/:player/matches'; //new for player matches

        Vue.prototype.$PLAYER_STATS_API = process.env.API_URL + 'api/player/:player/Batting-Bowling-Stats';  //player stats


        Vue.prototype.$TEAM_RESULTS_API = process.env.API_URL + 'api/tournament/:tournament/team/:team/results';
        Vue.prototype.$TEAM_PLAYERS_API = process.env.API_URL + 'api/tournament/:tournament/team/:team/players';

        Vue.prototype.$NEWS_LIST_API = process.env.API_URL + 'api/news';
        Vue.prototype.$ARTICLE_API = process.env.API_URL + 'api/news/:news?match=:match';
        Vue.prototype.$ARTICLE_MATCH_API = process.env.API_URL + 'api/news/match/:match';

        Vue.prototype.$HIGHLIGHTS_API = process.env.API_URL + 'api/highlights';

        Vue.prototype.$GENERAL_SEARCH_API = process.env.API_URL + 'api/search';
        Vue.prototype.$BOWLER_DETAIL = process.env.API_URL + 'api/playermatchbowl?playerslug=:player_slug&matchslug=:match_slug&inning=:inning';
        Vue.prototype.$BATSMAN_DETAIL = process.env.API_URL + 'api/playermatchscore?playerslug=:player_slug&matchslug=:match_slug&inning=:inning';
        Vue.prototype.$GETINNING_ORDER = process.env.API_URL + 'api/getinningorder?playerslug=:player_slug&matchslug=:match_slug&inninglength=:inninglength';
        Vue.prototype.$TOURNAMENT_NEWS_LIST_API = process.env.API_URL + 'api/tournament-news'; // new


    }
};
